// extracted by mini-css-extract-plugin
module.exports = {"modal_page":"ModalPageTransition_modal_page__lc6MT","internal_navigation":"ModalPageTransition_internal_navigation__MtfFC"};